import React from "react";
import {
  AlertCircle,
  CheckCircle2,
  X,
  Info,
  AlertTriangle,
} from "lucide-react";
import Card from "./Card";
import Button from "./Button";

const Alert = ({
  type = "info",
  message,
  onClose,
  details,
  showDetails,
  onToggleDetails,
}) => {
  const getIcon = () => {
    switch (type) {
      case "error":
        return (
          <AlertCircle className="h-5 w-5 text-red-600 mr-2 flex-shrink-0" />
        );
      case "success":
        return <CheckCircle2 className="h-5 w-5 text-green-600 mr-2" />;
      case "warning":
        return <AlertTriangle className="h-5 w-5 text-yellow-600 mr-2" />;
      case "info":
      default:
        return <Info className="h-5 w-5 text-blue-600 mr-2" />;
    }
  };

  const getStyles = () => {
    switch (type) {
      case "error":
        return "bg-gradient-to-r from-red-50 to-red-100/50 border-red-200/50 text-red-800";
      case "success":
        return "bg-gradient-to-r from-green-50 to-green-100/50 border-green-200/50 text-green-800";
      case "warning":
        return "bg-gradient-to-r from-yellow-50 to-yellow-100/50 border-yellow-200/50 text-yellow-800";
      case "info":
      default:
        return "bg-gradient-to-r from-blue-50 to-blue-100/50 border-blue-200/50 text-blue-800";
    }
  };

  const getButtonColor = () => {
    switch (type) {
      case "error":
        return "text-red-600 hover:text-red-800";
      case "success":
        return "text-green-600 hover:text-green-800";
      case "warning":
        return "text-yellow-600 hover:text-yellow-800";
      case "info":
      default:
        return "text-blue-600 hover:text-blue-800";
    }
  };

  return (
    <Card className={`mb-4 p-4 ${getStyles()}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {getIcon()}
          <span>{message}</span>
        </div>
        <div className="flex items-center space-x-2">
          {details && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onToggleDetails}
              className={getButtonColor()}
            >
              {showDetails ? "Hide" : "Show"} Details
            </Button>
          )}
          {onClose && (
            <button onClick={onClose} className={getButtonColor()}>
              <X className="h-5 w-5" />
            </button>
          )}
        </div>
      </div>
      {showDetails && details && (
        <div className="mt-4 p-4 bg-white/50 rounded-lg text-sm">
          <pre className="whitespace-pre-wrap overflow-x-auto">
            {typeof details === "string"
              ? details
              : JSON.stringify(details, null, 2)}
          </pre>
        </div>
      )}
    </Card>
  );
};

export default Alert;
